import { DesktopMacOutlined } from '@mui/icons-material';
import { Avatar, SxProps, Theme } from '@mui/material';

import { getUserInitials, isSystemUser } from '../utils';

type Props = {
    email: string;
    sx?: SxProps<Theme>;
};

/**
 * Avatar component for activity items
 * Shows user initials or a system icon for system-triggered actions
 */
const UserAvatar = ({ email, sx }: Props) => {
    const isSystem = isSystemUser(email);
    const initials = getUserInitials(email).toUpperCase();

    const avatarSx: SxProps<Theme> = {
        width: 36,
        height: 36,
        fontSize: '0.875rem',
        fontWeight: 600,
        bgcolor: 'grey.200',
        color: 'text.secondary',
        ...sx,
    };

    if (isSystem) {
        return (
            <Avatar sx={avatarSx}>
                <DesktopMacOutlined sx={{ fontSize: '1.25rem' }} />
            </Avatar>
        );
    }

    return <Avatar sx={avatarSx}>{initials}</Avatar>;
};

export default UserAvatar;
